const AuroraSiteTour = (function () {
  const settings = {
    name: "aurora-site-tour.js",
    enable: document.querySelector(".js--site-tour-popup").getAttribute("data-site-tour-enable") === "true" ? true : false,
    debugging: true,
    delay: parseInt(document.querySelector(".js--site-tour-popup").getAttribute("data-site-tour-delay")),
    isSiteFrench: AuroraUtils.isSiteFrench(),
  };

  const assets = window.theme.assets || {};

  const cookie = {
    duration: parseInt(document.querySelector(".js--site-tour-popup").getAttribute("data-site-tour-cookie-duration") || 7),
    name: "tour-closed",
  };

  const elements = {
    button: {
      start: document.querySelector("#start-tour"),
      close: document.querySelectorAll(".js--close-site-tour") || [],
    },
    steps: {
      container: document.querySelector(".aur-popup-steps"),
    },
    highlight: document.querySelectorAll(".aur-highlight-id") || [],
    popup: document.querySelector(".js--site-tour-popup"),
    popupTour: document.querySelectorAll(".aur-popup-tours"),
    startTourBtn: document.querySelector("#start-tour"),
    submenu: document.querySelectorAll(".aur-site-header .aur-menu > li:has(ul) > a") || [],
  };

  const triggerKeywords = ["Tour", "Visite"];

  const step = {
    items: [],
    count: 0,
  };

  async function getSteps(template = "index", language = "en") {
    const today = new Date();
    const cachedTour = JSON.parse(localStorage.getItem("site-tour") || "{}");
    const cachedTourDate = cachedTour?.[language]?.[template]?.date || today;
    const cachedTourExpired = cachedTourDate <= today ? true : false;
    const cachedTourContent = cachedTour?.[language]?.[template]?.content || [];

    if (cachedTourContent.length && !cachedTourExpired) {
      return cachedTourContent;
    } else {
      const tour = await AuroraServices.getThemeAssetFromPath(assets.siteTour[language][template]);
      cachedTour[language] = {};
      cachedTour[language][template] = {};
      cachedTour[language][template].date = today;
      cachedTour[language][template].content = tour;
      localStorage.setItem("site-tour", JSON.stringify(cachedTour));
      return tour;
    }
  }

  function isVisibleStep(step = {}) {
    // return true if step visible, false if not
    const element = document.getElementById(step.id);
    const elementStyles = element ? getComputedStyle(element) : false;
    const elementDisplay = elementStyles ? elementStyles.getPropertyValue("display") : false;
    return element && elementDisplay && elementDisplay != "none" ? true : false;
  }

  async function init() {
    if (settings.debugging) console.log(`${settings.name} :: Start`, { settings });

    // get steps from theme assets directory
    let intervalID = false;
    const language = settings.isSiteFrench ? "fr" : "en";
    const template = elements.popup.getAttribute("data-site-tour-page-type");
    const steps = await getSteps(template, language);
    const stepsFiltered = steps.filter(isVisibleStep);

    // log steps
    settings.debugging && console.log({ steps, stepsFiltered });

    // store filtered steps in local step object for future fetching
    setSteps(stepsFiltered);

    // conditionally show tour
    if (showTour()) {
      intervalID = setInterval(() => {
        if (Cookies.get("_age_validated") === "true") {
          settings.debugging && console.log("age-gate closed!", Cookies.get("_age_validated"));
          clearInterval(intervalID);
          startTour(settings.delay);
        } else {
          settings.debugging && console.log("interval!");
        }
      }, 400);
    }

    // attach click event listener to start tour
    onClickStartTour();

    if (settings.debugging) console.log(`${settings.name} :: Complete`);
  }

  function attachEventListeners() {
    function handlClickClose(event) {
      event.preventDefault();
      stopTour();
    }

    function handlClickNavigation(event) {
      event.preventDefault();
      const button = event.target.closest(".aur-tour-nav-button");
      const buttonStep = button && button.getAttribute("data-step");
      console.log("[ handlClickNavigation() ] :: ", { button, buttonStep });
      goToStep(parseInt(buttonStep));
    }

    (document.querySelectorAll(".js--close-site-tour") || []).forEach((el) => {
      el.removeEventListener("click", handlClickClose);
      el.addEventListener("click", handlClickClose);
    });

    (document.querySelectorAll(".js--site-tour-navigation-button") || []).forEach((el) => {
      el.removeEventListener("click", handlClickNavigation);
      el.addEventListener("click", handlClickNavigation);
    });
  }

  function goToStep(index = 0) {
    // accounts for first "step" being an intro/welcome step
    const actualStepCount = step.count - 1;
    const stepItem = step.items[index];
    const stepItemElement = document.getElementById(stepItem?.id) || false;

    // remove body state classes
    document.body.classList.remove("aur-body-highlight-open");

    // remove sub nav menu state classes
    elements.submenu.forEach((el) => {
      el.parentElement.classList.remove("aur-submenu-open");
    });

    // fetch and remove all instances of ".aur-highlight-id"
    (document.querySelectorAll(".aur-highlight-id") || []).forEach((el) => {
      el.classList.remove("aur-highlight-id");
    });

    // conditionally set "visible" states to stepItemElement
    if (stepItemElement) {
      if (stepItem.dropdown != "false") {
        stepItemElement.classList.add("aur-submenu-open");
      }
      stepItemElement.classList.add("aur-highlight-id");
      if (index > 0) {
        document.body.classList.add("aur-body-highlight-open");
      }
    }

    // set visibility state on step with class "aur-popup-inner-open"
    document.querySelectorAll(".aur-popup-tours .aur-popup-inner").forEach((stepItem) => {
      stepItem.classList.remove("aur-popup-inner-open");
      if (index == stepItem.dataset.step) {
        stepItem.classList.add("aur-popup-inner-open");
      }
    });

    if (index > 0) {
      scrollToStep(stepItemElement);
    }

    // update state on step progress, including percentage bar and step count, ie 1/8 -> 2/8
    updateStepProgress(index, actualStepCount);
  }

  function onClickStartTour() {
    const links = Array.from(document.querySelectorAll("a"));
    const filteredLinks = links.filter((link) => {
      const linkContent = link.textContent.trim();
      return triggerKeywords.includes(linkContent);
    });

    console.log("onClickStartTour ::", { filteredLinks });

    filteredLinks.forEach((link) => {
      link.addEventListener("click", (event) => {
        // prevent default link behaviour
        event.preventDefault();
        // start tour
        startTour();
      });
    });
  }

  function scrollToStep(element = false) {
    if (element) {
      const elementRect = element.getBoundingClientRect();
      const elementOffSetTop = elementRect.top + window.scrollY - 60;

      window.scrollTo({
        top: elementOffSetTop,
        left: 0,
        behavior: "smooth",
      });
    }
  }

  function renderSteps(steps = [], stepsCount = 0) {
    if (elements.steps.container) {
      // clear div to prepare for steps
      elements.steps.container.innerHTML = "";
      steps.forEach((step, index) => {
        const lastStep = index + 1 === stepsCount ? true : false;
        elements.steps.container.append(AuroraTemplates.siteTourStep(index, step, lastStep));
      });
    }
  }

  function setSteps(steps = []) {
    step.items = steps;
    step.count = steps.length;
  }

  function showTour() {
    if ((Shopify.designMode && !settings.enable) || Cookies.get(cookie.name) || window.innerWidth < 992) {
      return false;
    } else {
      return true;
    }
  }

  function startTour(delay = 0) {
    // set cookie
    Cookies.set(cookie.name, "false", { expires: cookie.duration });

    // render steps
    renderSteps(step.items, step.count);

    // attach event listeners to dynamic content
    attachEventListeners();

    // go to first step
    goToStep(0);

    // start tour
    setTimeout(() => {
      elements.popupTour.forEach((el) => el.classList.add("aur-popup-tours-open"));
      document.body.classList.add("aur-body-highlight-open", "site-tour--active");
    }, delay);
  }

  function stopTour() {
    // set cookie
    Cookies.set(cookie.name, "true", { expires: cookie.duration });

    // remove state-based classes from elements and body
    elements.popupTour.forEach((el) => el.classList.remove("aur-popup-tours-open"));
    elements.submenu.forEach((el) => el.classList.remove("aur-submenu-open"));
    elements.highlight.forEach((el) => el.classList.remove("aur-highlight-id"));
    document.body.classList.remove("aur-body-highlight-open", "site-tour--active");
  }

  function updateStepProgress(index = 0, actualStepCount = 1) {
    if (0 === index) {
      document.querySelector(".aur-tour-progress").classList.remove("aur-tour-progress-open");
    } else {
      document.querySelector(".aur-tour-progress").classList.add("aur-tour-progress-open");
    }

    if (actualStepCount > 1) {
      document.querySelector(".aur-tour-progress-meter-inner").style.width = `${(index / actualStepCount) * 100}%`;
      document.querySelector(".aur-tour-active").innerHTML = index;
      document.querySelector(".aur-tour-total").innerHTML = actualStepCount;
    }
  }

  return { init };
})();